function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 6.14467V2.65766C1 2.65766 2.23102 2.66358 3.25187 2.16036C4.27273 1.65714 5 1 5 1C5 1 5.94182 1.67787 7.10727 2.16036C8.27273 2.64286 9 2.65766 9 2.65766V6.57964C9 8.1753 6.24419 9.59298 5.30743 10.1204C5.1206 10.2265 4.8794 10.2265 4.69257 10.1204C3.75581 9.59298 1 8.46539 1 6.14467Z",
  stroke: "#4C4C4C",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 5.17109,
  y1: 3.55,
  x2: 5.17109,
  y2: 7.65,
  stroke: "#4C4C4C",
  strokeWidth: 1.1,
  strokeLinecap: "round"
});

const SvgAuthorizer = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "authorizer",
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAuthorizer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/authorizer.ef1e62d8.svg";
export { ForwardRef as ReactComponent };